import { Box, Td, Tr } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { AnimateElement } from "utils/animations";

export function AccordionTableRow({
  columnsLength,
  index,
  activeIndex,
  onClose,
  children,
}: {
  index: number;
  columnsLength: number;
  activeIndex: number | undefined;
  onClose?: () => void;
  children: any;
}) {
  const isOpen = activeIndex === index;
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const boxRef = useRef<HTMLDivElement>(null);

  const onOpenAnimation = () => {
    const container = boxRef.current;
    const containerHeight = container?.clientHeight!;
    const children = container?.children[0];
    const childrenHeight = children?.clientHeight;
    if (container && children) {
      const start = containerHeight / childrenHeight!;
      const stop = 1;
      const maxTiming = 200;
      const timing = Math.abs(stop - start) * maxTiming;
      AnimateElement(
        timing,
        [start, stop],
        (progress) => {
          if (container && childrenHeight) {
            const rowStyle = container.style;
            const currentHeight = progress * childrenHeight;
            rowStyle.opacity = `${progress}`;
            rowStyle.maxHeight = `${currentHeight}px`;
          }
        },
        () => {}
      );
    }
  };

  const onCloseAnimation = () => {
    const container = boxRef.current;
    const containerHeight = container?.clientHeight!;
    const children = container?.children[0];
    const childrenHeight = children?.clientHeight;
    if (container && children) {
      const start = containerHeight / childrenHeight!;
      const stop = 0;
      const maxTiming = 200;
      const timing = start * maxTiming;
      AnimateElement(
        timing,
        [start, stop],
        (progress) => {
          if (container && childrenHeight != null) {
            const rowStyle = container.style;
            const currentHeight = progress * childrenHeight;
            rowStyle.opacity = `${progress}`;
            rowStyle.maxHeight = `${currentHeight}px`;
          }
        },
        () => {
          setInternalIsOpen(false);
          onClose?.();
        }
      );
    }
  };

  useEffect(() => {
    if (internalIsOpen) onOpenAnimation();
  }, [internalIsOpen]);

  useEffect(() => {
    if (isOpen) setInternalIsOpen(true);
    else onCloseAnimation();
  }, [isOpen]);

  useEffect(() => {
    const child = boxRef.current?.children?.[0] as HTMLElement | undefined;
    if (!child || !internalIsOpen) return;

    let lastHeight = child.offsetHeight; // Pega a ultima altura

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const newHeight = entry.contentRect.height;

        if (newHeight !== lastHeight) {
          // Compara se a ultima altura for diferente, ele vai reajustar
          lastHeight = newHeight;
          onOpenAnimation();
        }
      }
    });

    observer.observe(child);

    return () => observer.disconnect();
  }, [internalIsOpen]);

  return internalIsOpen ? (
    <Tr p="0px">
      <Td colSpan={columnsLength} p="0">
        <Box ref={boxRef} overflow="hidden" maxH={0}>
          <Box w="100%">{children}</Box>
        </Box>
      </Td>
    </Tr>
  ) : null;
}
